// extracted by mini-css-extract-plugin
module.exports = {"layout":"promo-graphic_layout__vrt4i","heroGraphic":"promo-graphic_heroGraphic__G6W2M","descriptor":"promo-graphic_descriptor__T7KEn"};